import { Loader, Icon, AutoCompleteSearchInput } from '@nile/components';
import {
  AccountClient,
  GET_HOMEPAGE_WIDGETS_LIST,
  useCachedQuery
} from '@nile/graphql';
import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { DisplayText, Button, Banner, Page } from '@superops/ui-design-system';
import { useQuery } from '@apollo/client';
import GroupedLibraryMenu from './GroupedLibraryMenu';

const moduleList = [
  {
    module: 'TICKET',
    title: 'admin.home.widgetlibrary.ticket.views',
    permission: 'tickets.view'
  },
  {
    module: 'TASK',
    title: 'admin.home.widgetlibrary.task.views',
    permission: 'taskViews.view'
  },
  // { module: 'PROJECT', title: 'admin.home.widgetlibrary.project.views' },
  {
    module: 'PATCH',
    title: 'admin.home.widgetlibrary.patch.views',
    permission: 'patchViews.view'
  },
  {
    module: 'ALERT',
    title: 'admin.home.widgetlibrary.alert.views',
    permission: 'alertView.view'
  },
  {
    module: 'ASSET_VIEWS',
    title: 'asset.sidebar.assetViews',
    permission: 'assetViews.view'
  }
];
function WidgetLibrary(props) {
  const [filterExpression, setFilterExpression] = useState('');

  const flags = useFlags();

  const { loading, data } = useQuery(GET_HOMEPAGE_WIDGETS_LIST, {
    client: AccountClient,
    variables: {
      listInfo: {}
    },
    fetchPolicy: 'network-only'
  });

  const allViews = data?.getAllHomePageWidgets?.homePageWidgets
    ? moduleList.map((entry) => ({
        name: entry.title,
        permission: entry.permission,
        items: data?.getAllHomePageWidgets?.homePageWidgets.filter(
          (el) =>
            el.widgetType === 'LISTVIEW' &&
            el?.listView?.module === entry.module
        )
      }))
    : [];

  const debouncedFilter = useCallback((value) => {
    setFilterExpression(value.toLowerCase());
  });

  const allMentions = data?.getAllHomePageWidgets?.homePageWidgets?.filter(
    (el) => el.widgetType === 'MENTION'
  );

  return (
    <div className="fh w900">
      <Page
        variant="primary"
        contentHeight="80px"
        title={
          <div className="flex g10 actr">
            <FormattedMessage id="admin.home.widgetlibrary" />
            {props.disable ? (
              <DisplayText size="large" weight="Regular">
                <Banner status="info">{props.disabledInfoText}</Banner>
              </DisplayText>
            ) : null}
          </div>
        }
        fullWidth
        primaryAction={
          <Button
            onClick={() => {
              props.toggleWidgetLibrary();
            }}
          >
            <FormattedMessage id="common.close" />
          </Button>
        }
      >
        {loading ? (
          <Loader />
        ) : (
          <div
            disable={props.disable}
            className={`hc-50 fh ${
              props.disable ? 'opacity5 pointer-events-none' : ''
            }`}
          >
            <GroupedLibraryMenu
              allViews={allViews}
              allMentions={allMentions}
              handleClick={props.addWidget}
              layout={props.layout}
              debouncedFilter={debouncedFilter}
              filterExpression={filterExpression}
              isInClientDetailsPage={props.isInClientDetailsPage}
            />
          </div>
        )}
      </Page>
    </div>
  );
}

export default WidgetLibrary;
